const RTL_LOCALES = [
    'he',
    'fa',
    'ha',
    'ar',
    'ku',
    'ur'
]; // took top 6 from here - https://meta.wikimedia.org/wiki/Template:List_of_language_names_ordered_by_code
export const calcDirection = (locale) => {
    return RTL_LOCALES.indexOf(locale) !== -1 ? 'rtl' : 'ltr';
};
